<template>
  <div
    class="text-normal-emphasis font-bold text-lg" >
        <slot></slot>
    </div>
</template>
